import { api } from '@/lib/axios';
import type { UserSiteAccess } from '@monitor/shared';

export async function fetchMySites(): Promise<UserSiteAccess[]> {
  const { data } = await api.get<UserSiteAccess[]>('/api/sites');
  return data;
}

// ── Per-site MQTT auth (super_admin) ──────────────────────────────────────────
export interface SiteMqttAuthStatus {
  username: string | null;
  hasPassword: boolean;
  enabled: boolean;
}

export async function fetchSiteMqttAuth(siteId: number): Promise<SiteMqttAuthStatus> {
  const { data } = await api.get<SiteMqttAuthStatus>(`/api/sites/${siteId}/mqtt-auth`);
  return data;
}

export async function setSiteMqttCreds(
  siteId: number,
  username: string,
  password: string,
): Promise<SiteMqttAuthStatus> {
  const { data } = await api.put<SiteMqttAuthStatus>(
    `/api/sites/${siteId}/mqtt-auth/credentials`,
    { username, password },
  );
  return data;
}

export async function clearSiteMqttCreds(siteId: number): Promise<SiteMqttAuthStatus> {
  const { data } = await api.delete<SiteMqttAuthStatus>(`/api/sites/${siteId}/mqtt-auth/credentials`);
  return data;
}

export async function setSiteMqttEnforce(
  siteId: number,
  enabled: boolean,
): Promise<SiteMqttAuthStatus> {
  const { data } = await api.put<SiteMqttAuthStatus>(
    `/api/sites/${siteId}/mqtt-auth/enforce`,
    { enabled },
  );
  return data;
}
